import { Box, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const AddonHeading = styled(Text)`
  color: #040222;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin-top: 16px;
  margin-left: 0px;
`;

export const AddonDesc = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  span {
    font-weight: 600;
  }
  .price-text {
    color: #d83d37;
  }
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  padding-top: 20px;

  flex-direction: column;
  align-items: center;
  gap: 20px;
  box-sizing: border-box;
`;

export const AddonWrapper = styled(Box)`
  @media (min-width: 768px) {
    // padding: 0px 32px 0px 32px;
  }
`;

export const VariantOptionsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`;

export const VariantOption = styled(Box)<{ selected?: boolean }>`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 8px;
  border-radius: 12px;
  border: 1px solid #0fa457;
  background: #f3faf7;
  cursor: pointer;
  width: auto;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      color: #040222;
      font-size: 16px;
      font-weight: 600;
    }

    div {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
`;

export const SpecialOfferTag = styled(Box)`
  display: inline-flex;
  padding: 4px 8px;
  align-items: center;
  border-radius: 4px;
  background: #fff1f6;
  color: #e41d66;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
`;

export const StrikethroughPrice = styled(Text)`
  color: #666666;
  font-size: 14px;
  font-weight: 400;
  text-decoration: line-through;
`;

export const ActualPrice = styled(Text)`
  color: #040222;
  font-size: 16px;
  font-weight: 600;
`;
